var ComparisonQuestionGroupsDoc, DbHelper, MULTI_COMPARISON_PREFIX, OverarchingQuestionDoc, Router, W, alt, appUtils, callMethod, generateActions, generateGUID, getCurrentQuestion, mediator, _ref;

appUtils = require('lib/app_utils');

generateActions = require('actions/utils/generate_actions');

OverarchingQuestionDoc = require('lib/db_docs/overarching_question_doc');

ComparisonQuestionGroupsDoc = require('lib/db_docs/comparisons_question_groups_doc');

_ref = require('base/lib/utils'), callMethod = _ref.callMethod, generateGUID = _ref.generateGUID;

Router = require('router');

mediator = require('mediator');

alt = require('alt');

DbHelper = require('base/lib/db_helper');

MULTI_COMPARISON_PREFIX = require('lib/doc_prefixes').multiComparisonQuestion;

W = require('when/when');

getCurrentQuestion = function() {
  return alt.stores.OverarchingQuestionsStore.getCurrentQuestion();
};

module.exports = generateActions({
  autoGenerate: ['addCode', 'addIncludedQuestion', 'addTag', 'clearIncludedTags', 'createEmptyQuestion', 'dbChange', 'destroyCurrentQuestion', 'fetchCodesSuccess', 'fetchError', 'fetchOneSuccess', 'fetchSuccess', 'moveTag', 'removeCode', 'removeIncludedQuestion', 'removeTag', 'showExportDialog', 'hideExportDialog', 'updateCurrentQuestion', 'updateCurrentQuestionType', 'updateIncludedQuestion', 'updateMetadata', 'updateTag'],
  name: 'OverarchingQuestionsActions',
  actions: {
    fetch: function(projectId) {
      this.dispatch();
      return OverarchingQuestionDoc.at(projectId).fetchMany().then((function(_this) {
        return function(docs) {
          return _this.actions.fetchSuccess(Immutable.fromJS(_.chain(docs).compact().map(function(doc) {
            return [doc._id, doc];
          }).object().value()));
        };
      })(this))["catch"](this.actions.fetchError);
    },
    fetchOne: function(questionId) {
      this.dispatch();
      return OverarchingQuestionDoc.at(mediator.project.id, questionId).fetch().then((function(_this) {
        return function(res) {
          _this.actions.fetchOneSuccess(res);
          return res;
        };
      })(this))["catch"](this.actions.fetchError);
    },
    saveCurrentQuestion: function(question) {
      var currentQuestion;
      if (question == null) {
        question = null;
      }
      this.dispatch();
      currentQuestion = question || getCurrentQuestion();
      return OverarchingQuestionDoc.at(mediator.project.id).save(currentQuestion.toJS()).then((function(_this) {
        return function(doc) {
          return _this.actions.goToOverarchingRecommendations(doc._id);
        };
      })(this))["catch"](appUtils.errorHandler);
    },
    createQuestion: function(question, groupId) {
      if (groupId == null) {
        groupId = null;
      }
      return OverarchingQuestionDoc.at(mediator.project.id).save(question.toJS()).then(function(doc) {
        if (groupId) {
          ComparisonQuestionGroupsDoc.at(mediator.project.id).updateAsInstance(callMethod('addQuestionToGroup', doc._id, groupId));
        }
        return doc;
      }).then((function(_this) {
        return function(doc) {
          return _this.actions.goToOverarchingRecommendations(doc._id);
        };
      })(this))["catch"](appUtils.errorHandler);
    },
    goToOverarchingCreator: function(_arg) {
      var creating, groupId, id, questionId, route, submodule, url;
      groupId = _arg.groupId, questionId = _arg.questionId, creating = _arg.creating;
      id = questionId || ("" + MULTI_COMPARISON_PREFIX + (generateGUID()));
      submodule = creating ? 'create' : 'edit';
      url = groupId ? "/overarching-questions/" + groupId + "/" + id + "/" + submodule : "/overarching-questions/" + id + "/" + submodule;
      route = Router.prototype.getProjectRelativeUrl(url);
      return mediator.publish('!router:route', route);
    },
    goToOverarchingRecommendations: function(questionId) {
      var route;
      route = Router.prototype.getProjectRelativeUrl("/overarching-questions/" + questionId + "/details");
      return mediator.publish('!router:route', route);
    },
    "delete": function(projectId, questionId) {
      return OverarchingQuestionDoc.at(projectId, questionId)["delete"]();
    }
  }
});
